import React from "react";
import { motion } from "framer-motion";

const Url = ({
  infoObjectName,
  path,
  name,
  data,
  rendererOptions: { hideKeys, color },
}) => {
  const linkStyle = {
    color: color || "#0066cc",
    textDecoration: "none",
    fontSize: "0.875rem",
    wordBreak: "break-all",
  };

  const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data);
  const href = isEmail ? `mailto:${data}` : data;

  const handleClick = (e) => {
    e.stopPropagation();
  };

  return (
    <motion.a
      href={href}
      target={isEmail ? undefined : "_blank"}
      rel={isEmail ? undefined : "noopener noreferrer"}
      style={linkStyle}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      data-renderer="url"
      onClick={handleClick}
    >
      {data || ""}
    </motion.a>
  );
};

export default Url;
